import React from 'react';
import styled from 'styled-components';


const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const Th = styled.th`
  background-color: #f2f2f2;
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

const Img = styled.img`
  max-width: 70px;
  max-height: 70px;
`;

const ProductoTable = ({ productos }) => {
  return (
    <Table>
      <thead>
        <tr>
          <Th>Imagen</Th>
          <Th>Tipo</Th>
          <Th>Descripción</Th>
          <Th>Precio</Th>
        </tr>
      </thead>
      <tbody>
        {productos.map((producto) => (
          <tr key={producto.id}>
           
            <Td><Img src={producto.imagen} alt={producto.id} /></Td>
            <Td>{producto.tipo}</Td>
            <Td>{producto.descripcion}</Td>
            <Td>{producto.precio}</Td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProductoTable;